import { render, staticRenderFns } from "./ScratchCardPreview.vue?vue&type=template&id=0aac7ec0&scoped=true&"
import script from "./ScratchCardPreview.vue?vue&type=script&lang=ts&"
export * from "./ScratchCardPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ScratchCardPreview.vue?vue&type=style&index=0&id=0aac7ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aac7ec0",
  null
  
)

export default component.exports